import { createSlice } from '@reduxjs/toolkit';
import { mockSlots } from '../../mock/slotsData';

export const slotSlice = createSlice({
  name: 'slot',
  initialState: {
    loading: false,
    error: {},
    // slot
    slotList: { response: mockSlots },
    slotDropList: [],
    slotDetails: {},
  },
  reducers: {
    clearSlotError: (state) => {
      state.error = true;
    },
  },
});
export const { clearSlotError } = slotSlice.actions;

export default slotSlice.reducer;
